import React from 'react';
import { StyleSheet, Text, View } from 'react-native';

import { scale } from '@components/frame';
import { font } from '@styles/fonts';
import TouchableElement from '@components/common/touchableElement';

import type { ChipProps } from '@components/tenantStatus/onboardingWizard/types';

const Chip = ({ C, label, selected, onPress, testID }: ChipProps) => {
  const backgroundColor = selected ? C('Other/Light/Logo/Smart') : 'transparent';
  const borderColor = selected ? C('Other/Light/Logo/Smart') : C('Hairline/Light/Secondary');
  const labelColor = selected ? C('Label/Light/AlwaysLight Primary') : C('Label/Light/Primary');

  return (
    <TouchableElement onPress={onPress} testID={testID}>
      {({ boxStyle }) => (
        <View
          style={[
            boxStyle,
            {
              paddingHorizontal: scale(14),
              paddingVertical: scale(7),
              borderRadius: scale(18),
              borderWidth: StyleSheet.hairlineWidth,
              borderColor,
              backgroundColor,
              marginRight: scale(8),
              marginBottom: scale(8),
            },
          ]}
        >
          <Text style={[font['Subhead 2'], { color: labelColor }]}>{label}</Text>
        </View>
      )}
    </TouchableElement>
  );
};

export default Chip;
